module.exports = __webpack_public_path__ + "578171a9f4d0eb20ee0533faaca28e86.svg";